import React, { Suspense } from 'react'
import styled from 'styled-components'

const LazyQuiqupLogo = React.lazy(() =>
  import('../../assets/quiqup-with-name.svg').then((module) => {
    const Image = () => (
      <img alt="Quiqup" src={module.default} width={140} loading="lazy" />
    )
    return { default: Image }
  })
)

const Container = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 0.87rem;
`

function PoweredBy() {
  return (
    <Container>
      <a href="https://www.quiqup.com/" data-testid="site-link">
        <Suspense fallback={null}>
          <LazyQuiqupLogo />
        </Suspense>
      </a>
    </Container>
  )
}

export default PoweredBy
